import { gql } from '../../../artifacts/gql';

export const updateProfileName = gql(`
  mutation webUpdateProfileNameMutation($firstName: String!, $lastName: String!) {
    collectUpdateProfileName(firstName: $firstName, lastName: $lastName) {
        successful
        messages {
            message
            code
            field                        
        }
        result
    }
  }
`);
